// extracted by mini-css-extract-plugin
module.exports = {"tableHeaderRow":"styles_tableHeaderRow__uFf0Y"};